import React from 'react';
import Header from '../components/Header';
import Hero from '../components/Hero';
import ServicesSection from '../components/ServicesSection';
import DiferenciaisSection from '../components/DiferenciaisSection';
import ChamadoFormSection from '../components/ChamadoFormSection';
import Footer from '../components/Footer';

const LandingPage = () => {
  return (
    <div className="min-h-screen">
      <Header />
      <Hero />
      <ServicesSection />
      <DiferenciaisSection />
      <ChamadoFormSection />
      <Footer />
    </div>
  );
};

export default LandingPage;